/* ADD GROUPS */
export const LIST_REPORT6 = "LIST_REPORT6"
export const LIST_REPORT6_SUCCESS = "LIST_REPORT6_SUCCESS"
export const LIST_REPORT6_CLEAN = "LIST_REPORT6_CLEAN"
export const LIST_REPORT6_ERROR = "LIST_REPORT6_ERROR"
